import { FC, useState } from 'react';
import styles from './ChatManagementPopup.module.css';
import { Popup } from '../../Popup';
import { PopupTitle } from '../../PopupTitle';
import TooltipButton from '../../TooltipButton/TooltipButton';
import { Button } from '../../Button';
import { CopyField } from '../../CopyField';
import { ButtonGroup } from '../../ButtonGroup';
import PopupStructure from '../../PopupStructure';
import PopupTelegramChat from '../../PopupTelegramChat/PopupTelegramChat';
import PlatformInstruction from '../PlatformInstruction/PlatformInstruction';
import { useSocketApi } from '../../../hooks/useSocketApi';
import { Channel, useGetChannelsQuery } from '../../../features/api/apiSlice';
import { SelectedPlatform } from '../AddChannelPopup.interface';
import { useScreenWidth } from '../../../hooks/useScreenWidth';

interface ChatManagementPopupProps {
  botCommand: string;
  inviteUrl: string;
  onClose: () => void;
  channel: Channel;
}

const ChatManagementPopup: FC<ChatManagementPopupProps> = ({
  botCommand,
  onClose,
  inviteUrl,
  channel
}) => {
  const { isMobile } = useScreenWidth();
  const [isSettingsOpen, setIsSettingsOpen] = useState(Boolean(channel.telegram_chat));
  const { refetch, isLoading } = useGetChannelsQuery();

  useSocketApi({
    onTelegramLinkedSuccess: () => {
      refetch();
      setIsSettingsOpen(true);
    }
  });

  const handleConnect = () => {
    if (inviteUrl) {
      window.open(inviteUrl, '_blank');
    }
  };

  const handleCheckConnection = () => {
    refetch();
  };

  if (isSettingsOpen && channel.telegram_chat) {
    return (
      <PopupTelegramChat
        onClose={() => {
          setIsSettingsOpen(false);
          onClose();
        }}
        telegramChat={channel.telegram_chat}
        channelId={channel.id}
      />
    );
  }

  const telegramPlatform: SelectedPlatform = {
    platform: "telegram" as const,
    instructionLink: "https://restream.su/instruction#rec610353425"
  };

  return (
    <Popup isShow={true} maxWidth="530px" onClose={onClose}>
      <PopupStructure
        headerComponent={
          <PopupTitle>
            Настройки чата Telegram
          </PopupTitle>
        }
        contentComponent={
          <>
            <PlatformInstruction selectedPlatform={telegramPlatform} />

            <div className={styles['chat-management-popup__heading']}>
              Добавить бота в группу

              {!isMobile &&
                <TooltipButton
                  position="bottom-center"
                  text="Для интеграции бота в группу нажмите кнопку <b>Подключить</b>."
                  enableHtml
                />
              }
            </div>
            <div className={styles['chat-management-popup__section']}>
              <Button
                kind="primary"
                onClick={handleConnect}
                disabled={!inviteUrl}
              >
                Подключить
              </Button>
            </div>

            <div className={styles['chat-management-popup__heading']}>
              Подключение чата через команду
            </div>
            <div className={styles['chat-management-popup__section']}>
              <p className={styles['chat-management-popup__field-legend']}>
                Для подключения скопируйте и вставьте команду в группу, отправьте её от имени группы
              </p>
              <CopyField
                color="gray"
                type="text"
                defaultValue={botCommand}
                readOnly
              />
            </div>
          </>
        }
        footerComponent={
          <ButtonGroup className={styles['chat-management-popup__footer']}>
            <Button kind="secondary" onClick={onClose}>
              Отмена
            </Button>
            <Button
              kind="primary"
              onClick={handleCheckConnection}
              disabled={isLoading}
            >
              Проверка подключения
            </Button>
          </ButtonGroup>
        }
      />
    </Popup>
  );
};

export default ChatManagementPopup;